<div class="p-grid">
    <div class="p-col-12 notificationsBar">
        <div style="padding-right:5px;">
            <p-dataView #dvNotification [value]="app.notifications | globalFilter:globalFilterInputNotification" [paginator]="true" [rows]="10" [pageLinks]="3" layout="list" filterBy="name">
                <ng-template pTemplate="header">
                    <div class="p-d-flex p-flex-column p-flex-md-row p-jc-md-between">
                        <span class="p-input-icon-left" style="width: 100%;">
                            <i class="pi pi-search"></i>
                            <input type="search" style="width: 100%;" pInputText placeholder="Search..." (input)="dvNotification.filter($event.target.value)">
                        </span>
                    </div>
                    <div style="margin-top: 10px; position: relative; height: 20px;">
                        <div style="position: absolute; left: 0px">
                            <button *ngIf="app.showMARButton" pButton pRipple (click)="markAsRead()" type="button" label="Mark As Read"></button>
                        </div>
                        <div style="position: absolute; right: 0px">
                            <label for="sa">Select All</label>&nbsp;&nbsp;
                            <p-checkbox id="sa" name="sa" [(ngModel)]="checkedAll" (onChange)="checkAll()" binary="true" inputId="binary"></p-checkbox>
                        </div>
                    </div>
                </ng-template>
                <ng-template let-nLists pTemplate="list">
                    <div class="p-grid">
                        <div  *ngFor="let n of nLists; let i=index" class="p-col-12">
                            <!-- <div class="notification"   -->
                            <div class="notification" (click)="showDetail(n)" [ngClass]="{'endNotification': (i+1) == app.notifications.length}" style="cursor: pointer; position: relative;">
                                <div class="objectName"
                                [ngStyle]="{'background-image': 'url(' + assestBaseUrl + 'images/objectBG.png)'}">
                                    <span *ngIf="n.lionO360_Object && n.lionO360_Object.name">
                                        {{
                                        n?.lionO360_Object?.name == 'Task'
                                        ? (n?.description?.startsWith('TaskOverdue') ? 'Task Overdue' : n?.description?.startsWith('TaskAssigned') ?
                                        'Task Assigned' :
                                        n?.description?.startsWith('TaskReminder') ? 'Task Reminder' : n?.description?.startsWith('TaskInProgress') ?
                                        'Task InProgress' :
                                        n?.description?.startsWith('TaskShared') ? 'Task Shared' :
                                        n?.description?.startsWith('TaskCompleted') ? 'Task Completed'
                                        : n?.description?.startsWith('TaskUpdated')
                                        ? 'Task Updated'
                                         : n.lionO360_Object.name
                                        ): n.lionO360_Object.name
                                        }}

                                    </span>
                                    <span *ngIf="!n.lionO360_Object">
                                        No Module Name
                                    </span>
                                    <div class="read" (click)="$event.stopPropagation();">
                                        <p-checkbox [(ngModel)]="n.checked" (onChange)="showMarkAsRead()" binary="true" inputId="binary"></p-checkbox>
                                    </div>
                                </div>
                                <div class="notName">
                                    {{ n?.name?.length > 55 ? (n.name | slice:0:55) + '...' : n?.name }}
                                </div>
                                <div style="margin-top:5px;" class="description">
                                    <span [innerHTML]="n?.description?.includes('#') ? 
                                    (n?.description?.substring((n?.description.indexOf('#') + 1),n?.description?.length)) : 
                                    (n?.description | shorten:50)">
                                  </span>
                                </div>
                                <div style="margin:5px 0; text-align: right;">
                                    {{n.createdDate | localDate:'MM/DD/YYYY | h:mm a' }}
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </p-dataView>
        </div>
    </div>
</div>
